import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

// function* loginUserSaga({ payload, callBack, setLoading }) {
//   try {
//     const response = yield call(API.LOGIN_USER, payload);
//     if (response.data.message == "success") {
//       callBack && callBack();
//       setLoading(false);
//       yield put(ACTION.loginUser_Success(response.data));
//     } else {
//       toast.error(response.data.error);
//       setLoading(false);
//       yield put(ACTION.loginUser_Fail(error));
//     }
//   } catch (error) {
//     setLoading(false);
//     yield put(ACTION.loginUser_Fail(error));
//   }
// }


function* loginUserSaga({ payload, callBack, setLoading }) {
  try {
    const response = yield call(API.LOGIN_USER, payload);

    if (response?.data?.status === 200) {
      callBack && callBack(response.data);   
      setLoading(false);
      yield put(ACTION.loginUser_Success(response.data));
    } else {
      toast.error(response?.data?.error || "Login failed");
      setLoading(false);
      yield put(ACTION.loginUser_Fail(response?.data?.error));
    }
  } catch (error) {
    setLoading(false);
    toast.error("Server error");
  }
}

// function* verifyOtpSaga({ payload, callBack, setLoading }) {
//   try {
//     const response = yield call(API.VERIFY_OTP, payload);
//     if (response.data.data) {
//       toast.success("Login Successfully!");
//       localStorage.setItem("adminData", JSON.stringify(response.data.data));
//       localStorage.setItem(
//         "permissions",
//         JSON.stringify(response?.data?.data?.permissions)
//       );
//       localStorage.setItem("adminRole", response?.data?.data?.role);
//       localStorage.setItem("name", response.data.data.name);
//       localStorage.setItem("token", response.data.data.token);
//       localStorage.setItem("email", response.data.data.email);
//       localStorage.setItem("id", response.data.data.id);
//       setLoading(false);
//       callBack && callBack();
//       window.location.reload();
//       yield put(ACTION.loginUser_Success(response.data));
//     } else {
//       setLoading(false);
//       toast.error(response.data.error);
//       yield put(ACTION.loginUser_Fail(error));
//     }
//   } catch (error) {
//     setLoading(false);
//     yield put(ACTION.loginUser_Fail(error));
//   }
// }

function* verifyOtpSaga({ payload, callBack, setLoading }) {
  try {
    const response = yield call(API.VERIFY_OTP, payload);

    if (response?.data?.status === 200) {
      const admin = response.data.data;

   
      localStorage.setItem("adminData", JSON.stringify(admin));
      localStorage.setItem("permissions", JSON.stringify(admin.permissions));
      localStorage.setItem("adminRole", admin.role);
      localStorage.setItem("name", admin.name);
      localStorage.setItem("token", admin.token);
      localStorage.setItem("email", admin.email);
      localStorage.setItem("id", admin.id);

      toast.success("Login Successfully!");
      setLoading(false);

      callBack && callBack(response.data);    
      yield put(ACTION.verifyOtp_Success(response.data));
    } else {
      setLoading(false);
      toast.error(response?.data?.error || "Invalid OTP");
      yield put(ACTION.verifyOtp_Fail(response?.data?.error));
    }
  } catch (error) {
    setLoading(false);
    toast.error("Server error");
    yield put(ACTION.verifyOtp_Fail("Server error"));
  }
}


function* createPassSubadminSaga({ payload, callBack }) {
  try {
    const response = yield call(API.CREATE_PASS_SUBADMIN, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.createPassSubadmin_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.createPassSubadmin_Fail(error));
    }
  } catch (error) {
    yield put(ACTION.createPassSubadmin_Fail(error));
  }
}

// function* selectOtpOptionSaga({ payload, callBack, setLoading }) {
//   try {
//     const response = yield call(API.SELECT_OTP_OPTION, payload);
//     callBack && callBack(response.data);
//     if (response.data.data) {
//       setLoading(false);
//       yield put(ACTION.selectOtpOption_Success(response.data));
//     } else {
//       toast.error(response.data.error);
//       setLoading(false);
//       yield put(ACTION.selectOtpOption_Fail(error));
//     }
//   } catch (error) {
//     setLoading(false);
//     yield put(ACTION.selectOtpOption_Fail(error));
//   }
// }

function* selectOtpOptionSaga({ payload, callBack, setLoading }) {
  try {
    const response = yield call(API.SELECT_OTP_OPTION, payload);

    if (response?.data?.status === 200) {
      callBack && callBack(response.data);   
      setLoading(false);
      yield put(ACTION.selectOtpOption_Success(response.data));
    } else {
      toast.error(response?.data?.error || "OTP failed");
      setLoading(false);
      yield put(ACTION.selectOtpOption_Fail(response?.data?.error));
    }
  } catch (error) {
    setLoading(false);
    toast.error("Server error");
  }
}

function* LoginSaga() {
  yield takeEvery(CONST.LOGIN_USER, loginUserSaga);
  yield takeEvery(CONST.VERIFY_OTP, verifyOtpSaga);
  yield takeEvery(CONST.CREATE_PASS_SUBADMIN, createPassSubadminSaga);
  yield takeEvery(CONST.SELECT_OTP_OPTION, selectOtpOptionSaga);
}

export default LoginSaga;
